import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/wizard/memberships/$member-number/')({
  beforeLoad: (ctx) => {
    const { 'member-number': memberNumber } = ctx.params;
    throw redirect({
      to: '/wizard/memberships/$member-number/aliases',
      params: { 'member-number': memberNumber }
    });
  }
});
